/**
 * Page détail d'une fiche plateau — utilise <PedagogicalCanvas> trame Conduite.
 *
 * Route : /enseignant/terrain/:slug
 */
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import PedagogicalCanvas from '../components/teacher/PedagogicalCanvas';
import PresentationModeOverlay from '../components/teacher/PresentationMode';
import { getFichePlateauBySlug } from '../data/teacher/fichesPlateau';
import useSeo from '../hooks/useSeo';

export default function PlateauFiche() {
  const { slug } = useParams();
  const fiche = getFichePlateauBySlug(slug);
  const [presenting, setPresenting] = useState(false);

  useSeo({
    title: fiche
      ? `${fiche.title} · ${fiche.competence} · Plateau · Code 2 Roues`
      : 'Fiche plateau introuvable',
    description: fiche?.summary || 'Fiche plateau introuvable.',
    path: `/enseignant/terrain/${slug}`,
  });

  if (!fiche) {
    return (
      <div className="space-y-4 max-w-md mx-auto py-8" data-testid="fiche-not-found">
        <AlertCircle className="w-10 h-10 text-muted-foreground mx-auto" />
        <h1 className="text-xl font-black text-center">Fiche plateau introuvable</h1>
        <p className="text-sm text-muted-foreground text-center">
          La fiche &laquo; {slug} &raquo; n&apos;existe pas (ou plus).
        </p>
        <div className="flex justify-center">
          <Button asChild variant="outline">
            <Link to="/enseignant/terrain">
              <ArrowLeft className="w-4 h-4 mr-1.5" /> Retour Plateau
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid={`plateau-fiche-${fiche.slug}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <Link
          to="/enseignant/terrain"
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="w-4 h-4" /> Plateau · Toutes les fiches
        </Link>
        <Link
          to={`/enseignant/terrain/${fiche.slug}/presenter`}
          data-testid="open-presentation-pro"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs sm:text-sm font-black uppercase tracking-wider text-white shadow-lg transition-all hover:scale-105"
          style={{ background: 'linear-gradient(135deg, #0891b2 0%, #7c3aed 100%)' }}
        >
          🎬 Mode Pro · Studio
          <span className="text-[10px] font-black uppercase tracking-widest px-1.5 py-0.5 bg-white/20 rounded-md">NEW</span>
        </Link>
      </div>

      <PedagogicalCanvas
        trameId="conduite"
        title={fiche.title}
        kicker={fiche.kicker}
        meta={fiche.meta}
        steps={fiche.steps}
        accent={fiche.accent}
        testid={`canevas-${fiche.slug}`}
        onPresentToggle={() => setPresenting(true)}
      />

      {presenting && (
        <PresentationModeOverlay
          trameId="conduite"
          title={fiche.title}
          kicker={fiche.kicker}
          meta={fiche.meta}
          steps={fiche.steps}
          onClose={() => setPresenting(false)}
        />
      )}
    </div>
  );
}
